import { render, staticRenderFns } from "./Mops.vue?vue&type=template&id=180ca150&scoped=true"
import script from "./Mops.vue?vue&type=script&lang=js"
export * from "./Mops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ca150",
  null
  
)

export default component.exports